import type { SeasonalChallengeDescriptor } from "../config/seasonal-challenge-config";

export const halloween2026Season = {
  accessibility: {
    arenaLabel:
      "Halloween Haunt arena with a bright crescent moon, pumpkins, bats, and soft purple mist",
    decorationsLabel:
      "Decorative crescent moon, pumpkins, bats, and mist stay outside game controls",
    reducedMotionLabel:
      "Halloween decorations stay still and the lightest mist is hidden",
  },
  arena: {
    decorations: [
      {
        alpha: 0.12,
        color: 0x8b5cf6,
        heightRatio: 0.19,
        kind: "ellipse",
        reducedMotion: "hidden",
        widthRatio: 0.14,
        xRatio: 0.68,
        yRatio: 0.25,
      },
      {
        alpha: 0.2,
        color: 0xffe3a3,
        heightRatio: 0.16,
        kind: "crescent",
        reducedMotion: "static",
        widthRatio: 0.11,
        xRatio: 0.68,
        yRatio: 0.25,
      },
      {
        alpha: 0.16,
        color: 0xe9d5ff,
        heightRatio: 0.05,
        kind: "bat",
        reducedMotion: "static",
        widthRatio: 0.07,
        xRatio: 0.43,
        yRatio: 0.29,
      },
      {
        alpha: 0.14,
        color: 0xc4b5fd,
        heightRatio: 0.04,
        kind: "bat",
        reducedMotion: "static",
        widthRatio: 0.06,
        xRatio: 0.55,
        yRatio: 0.35,
      },
      {
        alpha: 0.18,
        color: 0xff8a2a,
        heightRatio: 0.08,
        kind: "pumpkin",
        reducedMotion: "static",
        widthRatio: 0.1,
        xRatio: 0.42,
        yRatio: 0.65,
      },
      {
        alpha: 0.16,
        color: 0xffa23f,
        heightRatio: 0.085,
        kind: "pumpkin",
        reducedMotion: "static",
        widthRatio: 0.11,
        xRatio: 0.73,
        yRatio: 0.64,
      },
      {
        alpha: 0.08,
        color: 0xa78bfa,
        heightRatio: 0.07,
        kind: "mist",
        reducedMotion: "hidden",
        widthRatio: 0.22,
        xRatio: 0.48,
        yRatio: 0.6,
      },
      {
        alpha: 0.07,
        color: 0xc4b5fd,
        heightRatio: 0.06,
        kind: "mist",
        reducedMotion: "hidden",
        widthRatio: 0.16,
        xRatio: 0.65,
        yRatio: 0.5,
      },
    ],
    highContrastPalette: {
      backgroundColor: 0x05020a,
      boundaryColor: 0xff8a1f,
      boundaryOutlineColor: 0xffffff,
      decorationColor: 0xe9d5ff,
      fieldColor: 0x15091f,
      foodHaloColor: 0xffffff,
      snakeOutlineColor: 0xffffff,
    },
    palette: {
      backgroundColor: 0x160b22,
      boundaryColor: 0xb94f23,
      boundaryOutlineColor: 0xffd28a,
      decorationColor: 0xb9a0d8,
      fieldColor: 0x2b1740,
      foodHaloColor: 0xfff7d6,
      snakeOutlineColor: 0xf7fff7,
    },
  },
  displayName: "Halloween Haunt",
  enabled: true,
  home: {
    activeDescription: "1 minute · Enter the Moonlit Patch",
    icon: "🎃",
    upcomingDescription: "Starts Aug 28 · 1-minute moonlit run",
  },
  mode: "challenge-1",
  results: {
    highlight: "Moonlit Patch conquered",
    modeLabel: "Halloween Haunt · 1 minute",
    outcome: "Spooky slither complete!",
  },
  rule: null,
  schedule: {
    endUtc: "2026-11-01T00:00:00.000Z",
    startUtc: "2026-08-28T00:00:00.000Z",
  },
  seedNamespace: "snakely:seasonal:v1:halloween-2026",
  share: {
    callToAction: "Enter the Moonlit Patch and beat my level.",
    displayName: "Halloween Haunt",
  },
  slug: "halloween-2026",
  version: 1,
} as const satisfies SeasonalChallengeDescriptor;
